import React from 'react';
import MariMessageContainer from './MariMessageContainer';
import styles from './mariMessage.module.css';

const MariMessageSection: React.FC = () => (
  <section className={styles.section}>
    <MariMessageContainer />
  </section>
);

export default MariMessageSection;
